import './App.scss';
import 'react-toastify/dist/ReactToastify.css';
import AppRouter from './router/AppRouter';
import { ToastContainer } from 'react-toastify';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import AppProvider from './context/AppProvider';

function gtag_report_conversion(url) {
  const callback = function () {
    if (typeof (url) != 'undefined') {
      window.location = url;
    }
  };
  window.gtag('event', 'conversion', {
    'send_to': 'GTM-M9V66VTT',
    'event_callback': callback
  });
  return false;
}

window.gtag_report_conversion = gtag_report_conversion; // Hacerla global si es necesario en otros componentes

function App() {
  return (
    <HelmetProvider>
      <AppProvider>
        <Helmet>
          {/* Google Tag Manager cargado en public/index.html (snippet oficial gtm.js). */}

          {/* Meta Pixel Code */}
          <script>
            {`
            !function(f,b,e,v,n,t,s)
            {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
            n.callMethod.apply(n,arguments):n.queue.push(arguments)};
            if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
            n.queue=[];t=b.createElement(e);t.async=!0;
            t.src=v;s=b.getElementsByTagName(e)[0];
            s.parentNode.insertBefore(t,s)}(window, document,'script',
            'https://connect.facebook.net/en_US/fbevents.js');
            fbq('init', '1597741034298193');
            fbq('track', 'PageView');
          `}
          </script>
          <noscript>{`
          <img height="1" width="1" style="display:none"
          src="https://www.facebook.com/tr?id=1597741034298193&ev=PageView&noscript=1" />
        `}</noscript>
        </Helmet>

        <AppRouter />
        <ToastContainer />
      </AppProvider>
    </HelmetProvider>
  );
}

export default App;
